import { assert } from '@Utils/assert';
import StructureOptionsDialog from '@Containers/StructureOptions/StructureOptionsDialog';
import { typeOfStructureOptionsDialog } from '@Containers/StructureOptions/StructureOptionsDialog/StructureOptionsDialogConstants';

import BarChartCheckboxesDialog from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartCheckboxesDialog';
import { typeOfBarChartCheckboxesDialog } from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartCheckboxesDialog/BarChartCheckboxesDialogConstants';

import TreeViewDialog from '@Containers/ResultsFilters/ResultsFiltersComponents/TreeViewDialog';
import { typeOfTreeViewDialog } from '@Containers/ResultsFilters/ResultsFiltersComponents/TreeViewDialog/TreeViewDialogConstants';

import ZeroFilterResults from '@Containers/ResultsFilters/ResultsFiltersComponents/ZeroFilterResults';
import { typeOfZeroFilterResults } from '@Containers/ResultsFilters/ResultsFiltersComponents/ZeroFilterResults/ZeroFilterResultsConstants';

import FilterByValueConfirmDialog from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartFilter/FilterByValueConfirmDialog';
import { typeOfFilterByValueConfirmDialog } from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartFilter/FilterByValueConfirmDialog/FilterByValueConfirmDialogConstants';

import LoginPromptDialog from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartFilter/LoginPromptDialog';
import { typeOfLoginPromptDialog } from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartFilter/LoginPromptDialog/LoginPromptDialogConstants';

import StructureDialog from '@Containers/StructureDialog';
import { typeOfStructureDialog } from '@Containers/StructureDialog/StructureDialogConstants';

import ResetPasswordWithTokenDialogContainer from '@Pages/Login/ResetPasswordWithTokenDialog';
import { typeOfResetPasswordWithTokenDialog } from '@Pages/Login/ResetPasswordWithTokenDialog/ResetPasswordWithTokenDialogConstants';

import { typeOfForgotPasswordDialog } from '@Pages/Login/ForgotPasswordDialog/ForgotPasswordDialogConstants';
import ForgotPasswordDialogContainer from '@Pages/Login/ForgotPasswordDialog';

import TooManySessionsModalContainer from '@Pages/Login/TooManySessionsModal';
import { typeOfLoginTooManySessionModal } from '@Pages/Login/TooManySessionsModal/TooManySessionsModalConstants';

import BulkIdRegisterModal from '@Pages/Login/BulkIdRegisterModal';
import { typeOfBulkIdRegisterModal } from '@Pages/Login/BulkIdRegisterModal/constants';

import AccountErrorModal from '@Pages/ProfileSettings/Account/Components/AccountErrorModal';
import { typeOfAccountErrorModal } from '@Pages/ProfileSettings/Account/AccountConstants';

import ProfileSettingsUserAgreementPrompt from '@Pages/ProfileSettings/UserAgreementPrompt/UserAgreementPrompt';
import { typeOfUserAgreementPrompt } from '@Pages/ProfileSettings/UserAgreementPrompt/UserAgreementPromptConstants';

import RegisterModalContainer from '@Pages/Login/Register/RegisterModalContainer';
import { typeOfRegisterModal } from '@Pages/Login/Register/RegisterConstants';
import LoginModalContainer from '@Pages/Login/LoginModalContainer';
import { typeOfLoginModal } from '@Pages/Login/LoginConstants';
import InstitutionModalContainer from '@Pages/Login/Institution/InstitutionModalContainer';
import { typeOfInstitutionModal } from '@Pages/Login/Institution/InstitutionConstants';

import BatchModal from '@Containers/Search/Shared/BatchFile';
import { typeOfBatchModal } from '@Containers/Search/Shared/BatchFile/BatchModalConstants';

import BatchSearchProgressModal from '@Containers/Search/Shared/BatchSearchProgress';
import { typeOfBatchSearchProgressModal } from '@Containers/Search/Shared/BatchSearchProgress/BatchSearchProgressModalConstants';

import SearchProgressModal from '@Containers/Search/Shared/SearchProgress';
import { typeOfSearchProgressModal } from '@Containers/Search/Shared/SearchProgress/SearchProgressModalConstants';

import SaveFormModal from '@Containers/SaveFormModal';
import { typeOfSaveFormModal } from '@Containers/SaveFormModal/SaveFormModalConstants';

import MolecularModal from '@Containers/MolecularModal';
import { typeOfMolecularModal } from '@Containers/MolecularModal/MolecularModalConstants';

import CopyStructureToQueryModal from '@Containers/CopyStructureToQueryModal';
import { typeOfCopyStructureToQueryModal } from '@Containers/CopyStructureToQueryModal/CopyStructureToQueryModalConstants';

import LogoutConfirmModal from '@Containers/LogoutConfirmModal';
import { typeOfLogoutConfirmModal } from '@Containers/LogoutConfirmModal/LogoutConfirmModalConstants';

import ReencryptionNotifyModal from '@Containers/ReencryptionNotifyModal';
import { typeOfReencryptionNotifyModal } from '@Containers/ReencryptionNotifyModal/ReencryptionNotifyModalConstants';

import IdleWarningModal from '@Containers/IdleWarningModal';
import { typeOfIdleWarningModal } from '@Containers/IdleWarningModal/IdleWarningModalConstants';

import TitlesAbstractsModal from '@Containers/TitlesAbstractsModal';
import { typeOfTitlesAbstractsModal } from '@Containers/TitlesAbstractsModal/TitlesAbstractsModalConstants';

import BatchExecutionDetailsModal from '@Containers/Search/Shared/BatchExecutionDetails';
import { typeOfBatchExecutionDetailsModal } from '@Containers/Search/Shared/BatchExecutionDetails/BatchExecutionDetailsModalConstants';

import ImportFileModal from '@Containers/Search/Shared/ImportFile';
import { typeOfImportFileModal } from '@Containers/Search/Shared/ImportFile/ImportFileModalConstants';

import FindSimilarModal from '@Containers/Search/Shared/FindSimilar';
import { typeOfFindSimilarModal } from '@Containers/Search/Shared/FindSimilar/FindSimilarModalConstants';

import SuggestModal from '@Containers/Search/SearchBuilder/SuggestModal';
import { typeOfSuggestModal } from '@Containers/Search/SearchBuilder/SuggestModal/SuggestModalConstants';

import TaxonomyLookupModal from '@Containers/Search/SearchBuilder/TaxonomyLookupModal';
import { typeOfTaxonomyLookupModal } from '@Containers/Search/SearchBuilder/TaxonomyLookupModal/TaxonomyLookupModalConstants';

import ExportModal from '@Containers/ExportModal';
import { typeOfExportModal } from '@Containers/ExportModal/ExportModalConstants';

import RcsSupplierInfoDialog from '@Containers/RcsSupplierInfo/RcsSupplierInfoDialog';
import { typeOfRcsSupplierInfoDialog } from '@Containers/RcsSupplierInfo/RcsSupplierInfoDialog/RcsSupplierInfoDialogConstants';

import AlertCreateDialog from '@Pages/Alerts/AlertsComponents/AlertCreateDialog';
import {
  typeOfAlertCreateDialog,
  typeOfAlertLoginDialog,
} from '@Pages/Alerts/AlertsComponents/AlertCreateDialog/AlertCreateDialogConstatns';

import HistoryConfirmationDialog from '@Pages/History/ConfirmationPopup';
import HistorySaveDialog from '@Pages/History/SaveModal';
import { typeOfHistoryConfirmationDialog, typeOfHistorySaveDialog } from '@Pages/History/Constants';

import AlertCreateSuccessDialog from '@Pages/Alerts/AlertsComponents/AlertCreateSuccessDialog';
import { typeOfAlertCreateSuccessDialog } from '@Pages/Alerts/AlertsComponents/AlertCreateSuccessDialog/AlertCreateSuccessDialogConstants';

import AlertZeroResultsDialog from '@Pages/Alerts/AlertsComponents/AlertZeroResultsDialog';
import { typeOfAlertZeroResultsDialog } from '@Pages/Alerts/AlertsComponents/AlertZeroResultsDialog/AlertZeroResultsDialogConstants';

import AlertIdNotFoundDialog from '@Pages/Alerts/AlertsComponents/AlertIdNotFoundDialog';
import { typeOfAlertIdNotFoundDialog } from '@Pages/Alerts/AlertsComponents/AlertIdNotFoundDialog/AlertIdNotFoundDialogConstants';

import ProjectParametersDialogContainer from '@Pages/RetroSynthesis/ProjectParametersDialog/ProjectParametersDialogContainer';
import SimilaritySearchDialogContainer from '@Pages/RetroSynthesis/SimilaritySearch/SimilaritySearchDialogContainer';
import {
  typeOfDialogWithConfirmationLayout,
  typeOfDialogWithErrorLayout,
  typeOfDialogWithInfoLayout,
  typeOfDialogWithSuccessLayout,
  typeOfDialogWithWarningLayout,
  typeOfRsProjectParametersDialog,
  typeOfRsSimilaritySearchDialog,
} from '@Containers/Dialogs/DialogsMapperConstants';

import remoteAccessDialogs from '@Containers/RemoteAccess/dialogs';
import resultSetValidationDialogs from '@Containers/ResultSetValidation/dialogs';
import GSFNDialogs from '@Pages/RetroSynthesis/DrawStructure/GSFN/dialogs';
import { typeOfRouteOverviewTreeDialog } from '@Pages/RetroSynthesis/RouteTree/components/RouteOverviewTreePopup';

import RouteOverviewTreePopupContainer from '@Pages/RetroSynthesis/RouteTree/RouteOverviewTreePopupContainer';
import RouteThumbnailsPopup, { typeOfRouteThumbnailDialog } from '@Pages/RetroSynthesis/RouteTree/components/RouteThumbnailsPopup';

import { typeOfMultiStepReactionDialog } from '@Pages/RetroSynthesis/MultiStepReactionDialog/constants';
import MultiStepReactionDialogContainer from '@Pages/RetroSynthesis/MultiStepReactionDialog/MultiStepReactionDialogContainer';

import { typeOfSynthesisJobRetryDialog } from '@Pages/RetroSynthesis/SynthesisJobRetry/constants';
import SynthesisJobRetryDialog from '@Pages/RetroSynthesis/SynthesisJobRetry/SynthesisJobRetryDialog';
import HopintoInvalidParamsDialog from '@Pages/Hopinto/HopintoInvalidParamsDialog';
import { typeOfHopintoInvalidParamsDialog } from '@Pages/Hopinto/constants';

import { typeOfFindPreparationsSimilaritySearchDialog } from '@Containers/FindPreparations/SimilatiySearch/constants';
import FindPreparationsSimilaritySearchDialog from '@Containers/FindPreparations/SimilatiySearch/SimilaritySearchDialogContainer';

import { typeOfHeatmapSettingsDialog } from '@Pages/Heatmap/HeatmapSettingsDialog/constants';
import HeatmapSettingsContainer from '@Pages/Heatmap/HeatmapSettingsDialog';

import { typeOfHeatmapCellDetailsDialog } from '@Pages/Heatmap/HeatmapCellDetailsDialog/constants';
import HeatmapCellDetailsDialogContainer from '@Pages/Heatmap/HeatmapCellDetailsDialog';

import { typeOfHeatmapLegendDialog } from '@Pages/Heatmap/HeatmapLegendDialog/constants';
import HeatmapLegendDialog from '@Pages/Heatmap/HeatmapLegendDialog';

import { typeOfHeatmapNavigatorDialog } from '@Pages/Heatmap/HeatmapNavigatorDialog/constants';
import HeatmapNavigatorDialog from '@Pages/Heatmap/HeatmapNavigatorDialog';

import registerConfirmationDialogs from '@Pages/Login/RegisterConfirmation/dialogs';
import AlertLoginDialog from '@Pages/Alerts/AlertsComponents/AlertLoginDialog/AlertLoginDialog';
import DialogWithConfirmationLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithConfirmationLayout';
import DialogWithErrorLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithErrorLayout';
import DialogWithInfoLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithInfoLayout';
import DialogWithWarningLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithWarningLayout';
import DialogWithSuccessLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithSuccessLayout';

export const dialogsMap = {
  [typeOfStructureOptionsDialog]: StructureOptionsDialog,
  [typeOfBarChartCheckboxesDialog]: BarChartCheckboxesDialog,
  [typeOfTreeViewDialog]: TreeViewDialog,
  [typeOfZeroFilterResults]: ZeroFilterResults,
  [typeOfFilterByValueConfirmDialog]: FilterByValueConfirmDialog,
  [typeOfLoginPromptDialog]: LoginPromptDialog,
  [typeOfStructureDialog]: StructureDialog,
  [typeOfRcsSupplierInfoDialog]: RcsSupplierInfoDialog,
  [typeOfAlertCreateDialog]: AlertCreateDialog,
  [typeOfAlertLoginDialog]: AlertLoginDialog,
  [typeOfHistoryConfirmationDialog]: HistoryConfirmationDialog,
  [typeOfHistorySaveDialog]: HistorySaveDialog,
  [typeOfAlertCreateSuccessDialog]: AlertCreateSuccessDialog,
  [typeOfAlertZeroResultsDialog]: AlertZeroResultsDialog,
  [typeOfAlertIdNotFoundDialog]: AlertIdNotFoundDialog,
  [typeOfRsProjectParametersDialog]: ProjectParametersDialogContainer,
  [typeOfRsSimilaritySearchDialog]: SimilaritySearchDialogContainer,
  [typeOfRouteOverviewTreeDialog]: RouteOverviewTreePopupContainer,
  [typeOfRouteThumbnailDialog]: RouteThumbnailsPopup,
  [typeOfMultiStepReactionDialog]: MultiStepReactionDialogContainer,
  [typeOfSynthesisJobRetryDialog]: SynthesisJobRetryDialog,
  [typeOfResetPasswordWithTokenDialog]: ResetPasswordWithTokenDialogContainer,
  [typeOfLoginTooManySessionModal]: TooManySessionsModalContainer,
  [typeOfBulkIdRegisterModal]: BulkIdRegisterModal,
  [typeOfUserAgreementPrompt]: ProfileSettingsUserAgreementPrompt,
  [typeOfAccountErrorModal]: AccountErrorModal,
  [typeOfRegisterModal]: RegisterModalContainer,
  [typeOfLoginModal]: LoginModalContainer,
  [typeOfInstitutionModal]: InstitutionModalContainer,
  [typeOfForgotPasswordDialog]: ForgotPasswordDialogContainer,
  [typeOfHopintoInvalidParamsDialog]: HopintoInvalidParamsDialog,
  [typeOfFindPreparationsSimilaritySearchDialog]: FindPreparationsSimilaritySearchDialog,
  [typeOfHeatmapSettingsDialog]: HeatmapSettingsContainer,
  [typeOfHeatmapCellDetailsDialog]: HeatmapCellDetailsDialogContainer,
  [typeOfHeatmapLegendDialog]: HeatmapLegendDialog,
  [typeOfHeatmapNavigatorDialog]: HeatmapNavigatorDialog,
  [typeOfBatchModal]: BatchModal,
  [typeOfBatchSearchProgressModal]: BatchSearchProgressModal,
  [typeOfSearchProgressModal]: SearchProgressModal,
  [typeOfSaveFormModal]: SaveFormModal,
  [typeOfCopyStructureToQueryModal]: CopyStructureToQueryModal,
  [typeOfLogoutConfirmModal]: LogoutConfirmModal,
  [typeOfReencryptionNotifyModal]: ReencryptionNotifyModal,
  [typeOfIdleWarningModal]: IdleWarningModal,
  [typeOfTitlesAbstractsModal]: TitlesAbstractsModal,
  [typeOfMolecularModal]: MolecularModal,
  [typeOfBatchExecutionDetailsModal]: BatchExecutionDetailsModal,
  [typeOfImportFileModal]: ImportFileModal,
  [typeOfFindSimilarModal]: FindSimilarModal,
  [typeOfSuggestModal]: SuggestModal,
  [typeOfTaxonomyLookupModal]: TaxonomyLookupModal,
  [typeOfExportModal]: ExportModal,
  [typeOfDialogWithConfirmationLayout]: DialogWithConfirmationLayout,
  [typeOfDialogWithErrorLayout]: DialogWithErrorLayout,
  [typeOfDialogWithInfoLayout]: DialogWithInfoLayout,
  [typeOfDialogWithWarningLayout]: DialogWithWarningLayout,
  [typeOfDialogWithSuccessLayout]: DialogWithSuccessLayout,
  ...remoteAccessDialogs,
  ...resultSetValidationDialogs,
  ...GSFNDialogs,
  ...registerConfirmationDialogs,
};

export default function dialogsMapper(dialogType) {
  const component = dialogsMap[dialogType];
  assert(component !== undefined, `Component for "dialogType": ${dialogType} is absent`);

  return component;
}
